import usePlayerStore from "../../store/playerStore";
import useTooltipStore from "../../store/tooltipStore";

import useDelayedText from "../../hooks/useDelayText";
import { playIcon, pauseIcon } from "../../assets/icons";

const PlayButton = () => {
  const isPlaying = usePlayerStore((state) => state.isPlaying);
  const togglePlayPause = usePlayerStore.getState().togglePlayPause;

  const { setTooltipText, handleButtonPress, handleMouseEnter, handleMouseLeave } = useTooltipStore.getState();

  useDelayedText(isPlaying, "一時停止", "再生");

  function handlePlayPause() {
    togglePlayPause();
    handleButtonPress();
  }

  function handlePlayPauseMouseEnter() {
    setTooltipText(isPlaying ? "一時停止" : "再生");
    handleMouseEnter();
  }

  return (
    <button
      onClick={handlePlayPause}
      className="player-controls__button player-controls__play-pause-button"
      onMouseEnter={handlePlayPauseMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img
        src={isPlaying ? pauseIcon : playIcon}
        className={`player-controls__play-pause-button-icon player-controls__${isPlaying ? "pause" : "play"}-icon`}
      />
    </button>
  );
};
export default PlayButton;
